var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "site-wrapper site-page--not-found" }, [
    _c("div", { staticClass: "site-content__wrapper" }, [
      _c(
        "div",
        { staticClass: "site-content" },
        [
          _vm._m(0),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("返回上一页")]
          ),
          _c(
            "el-button",
            {
              staticClass: "not-found-btn-gohome",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "home" })
                },
              },
            },
            [_vm._v("进入首页")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { "margin-bottom": "50px" } }, [
      _c("img", {
        attrs: { src: require("@/assets/images/500.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }